import React from "react"
import CustomPageHeader from "../fragments/CustomPageHeader"

export default function Reports({ children }) {
  return (
    <div>
      <CustomPageHeader icon='bar-chart-o' text='Reports' />
      { children }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Reports/index.js